// extracted by mini-css-extract-plugin
export default {"column-empty-state":"_2g6Mm___BuildingsTable-module__column-empty-state"};